var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0004,
    cy: 47.9066,
    r: 47.9066,
    fill: "#D12600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1683 60.1461H46.0513L44.2456 23.0929H51.9741L50.1683 60.1461ZM43.5956 70.7637C43.5956 68.9821 44.0289 67.7301 44.8957 67.0078C45.7624 66.2856 46.8218 65.9244 48.0737 65.9244C49.2775 65.9244 50.3128 66.2856 51.1795 67.0078C52.0944 67.7301 52.5519 68.9821 52.5519 70.7637C52.5519 72.4972 52.0944 73.7492 51.1795 74.5196C50.3128 75.29 49.2775 75.6753 48.0737 75.6753C46.8218 75.6753 45.7624 75.29 44.8957 74.5196C44.0289 73.7492 43.5956 72.4972 43.5956 70.7637Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWarning);
export default __webpack_public_path__ + "static/media/status_warning.c21034cf187f18296a8e412df7018c0c.svg";
export { ForwardRef as ReactComponent };